import RnStorageEnhance from '@qnpm/rn-storage-enhance';

export default new RnStorageEnhance('order_rn', 'OrderMain');
